import { faListCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ApplyButton = ({ className = '', ...props }) => {
    return (
        <button
            type="button"
            className={`btn btn-primary d-flex align-items-center ${className}`}
            {...props}
        >
            <FontAwesomeIcon icon={faListCheck} className='me-1 mb-1' />
            Apply
        </button>
    )
}

export default ApplyButton